import api from "../services/api";

export const createOptionsAutorizacao = (payload) =>
  api.post("/tipo-autorizacao/register", payload);

export const createOptionsRestricao = (payload) =>
  api.post("/restricao-autorizacao/register", payload);

export const getAutorizacoesConfig = async (tipoEstabelecimento) => {
  const { data } = await api.get(`/tipo-autorizacaos?tipoEstabelecimento=${tipoEstabelecimento}`);
  return data;
};

export const getRestricoesConfig = async () => {
  const { data } = await api.get("/restricao-autorizacaos");
  return data;
};

export const approveEstabelecimento = async (payload) => {
  return api.patch("/estabelecimento/approve", payload);
};

export const editAutorizacaoExercicio = async (payload) => {
  return api.put("/autorizacao/edit", payload);
};
